/* eslint-disable max-lines */
import { TFunction } from 'i18next';
import { SelectionGroupOption } from 'common/components';
import { ServiceTabName, ServiceGroupStructure } from './services-catalog-section-types';
import { SERVICES_MAIN_CDN_PATH } from '../../services-main-constants';

export const getServiceTabList = (t: TFunction): SelectionGroupOption[] => [
  {
    text: t('catalog-section.title'),
    value: ServiceTabName.All,
  },
  {
    text: t('catalog-section.tabs.design'),
    value: ServiceTabName.Design,
  },
  {
    text: t('catalog-section.tabs.construction'),
    value: ServiceTabName.Сonstruction,
  },
  {
    text: t('catalog-section.tabs.rough-work'),
    value: ServiceTabName.RoughWork,
  },
  {
    text: t('catalog-section.tabs.communications'),
    value: ServiceTabName.Communications,
  },
  {
    text: t('catalog-section.tabs.finishing'),
    value: ServiceTabName.Finishing,
  },
  {
    text: t('catalog-section.tabs.improvement'),
    value: ServiceTabName.Improvement,
  },
];

export const allTabData: ServiceGroupStructure[] = [
  {
    name: 'catalog-section.tabs.design',
    engName: 'design',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/design-new.png/design-new.png`,
    list: [
      'kitchen',
      'bathroom',
      'storage',
      'cabinet',
      '99999',
      'engineering-systems',
      'filter-systems',
      'power-supply-systems',
      'sewerage-systems',
      'ventilation-systems',
      'heating-systems',
    ],
  },
  {
    name: 'catalog-section.categories.floors',
    engName: 'floors',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/floors-new.png/floors-new.png`,
    list: ['floor-screed', '323', '2135', '324', '331', '1086'],
  },
  {
    name: 'catalog-section.categories.walls',
    engName: 'walls',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/walls-new.png/walls-new.png`,
    list: ['plastering', '334', '331', '979', '1631', '311', '2134', '1086'],
  },
  {
    name: 'catalog-section.categories.ceilings',
    engName: 'ceilings',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/ceilings-new.png/ceilings-new.png`,
    list: ['ceilings', '314', '979', '331', '1086'],
  },
  {
    name: 'catalog-section.categories.plumbing',
    engName: 'plumbing',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/plumbing-new.png/plumbing-new.png`,
    list: [
      'bathroom-repair',
      'bathroom',
      'sewerage-systems',
      'filter-systems',
      '325',
      '1972',
      '328',
      '2133',
      '1250',
      '1275',
      '329',
    ],
  },
  {
    name: 'catalog-section.categories.electrician',
    engName: 'electrician',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/electrician-new.png/electrician-new.png`,
    list: ['power-supply-systems', '322', '336', '1637'],
  },
  {
    name: 'catalog-section.categories.ventilation',
    engName: 'ventilation',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/ventilation-new.png/ventilation-new.png`,
    list: ['ventilation-systems', 'heating-systems', '321', '682'],
  },
  {
    name: 'catalog-section.categories.doors',
    engName: 'doors',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/doors-new.png/doors-new.png`,
    list: ['entrance-doors', 'room-doors', '1140', '1063'],
  },
  {
    name: 'catalog-section.categories.windows',
    engName: 'windows',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/windows-new.png/windows-new.png`,
    list: ['windows', '320', '1217', '2136'],
  },
  {
    name: 'catalog-section.categories.furniture',
    engName: 'furniture',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/furniture-new.png/furniture-new.png`,
    list: ['kitchen', 'storage', '1832', '337', '2237', '1972', '2524', '325', '859'],
  },
  {
    name: 'catalog-section.tabs.construction',
    engName: 'build',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/build-new.png/build-new.png`,
    list: ['foundation', 'metal-roof', '318', '1186', '1154', '311', '2137', 'construction-houses'],
  },
  {
    name: 'catalog-section.categories.garden',
    engName: 'garden',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/garden-new.png/garden-new.png`,
    list: ['fences', '330', '1245', '702', '859', '915', '1135', '1570', '1637'],
  },
  {
    name: 'Вывоз старых вещей\nна\u00A0переработку',
    engName: 'recycling',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/recycling.png/recycling.png`,
    list: ['2468', '2466', '2433', '2436', '2435'],
  },
];

export const designTabData: ServiceGroupStructure[] = [
  {
    name: 'catalog-section.tabs.design',
    engName: 'design',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/design-new.png/design-new.png`,
    list: ['kitchen', 'bathroom', 'storage', 'cabinet', '99999', 'engineering-systems'],
  },
  {
    name: 'catalog-section.categories.plumbing',
    engName: 'plumbing',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/plumbing-new.png/plumbing-new.png`,
    list: ['sewerage-systems', 'filter-systems'],
  },
  {
    name: 'catalog-section.categories.electrician',
    engName: 'electrician',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/electrician-new.png/electrician-new.png`,
    list: ['power-supply-systems'],
  },
  {
    name: 'catalog-section.categories.ventilation',
    engName: 'ventilation',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/ventilation-new.png/ventilation-new.png`,
    list: ['ventilation-systems', 'heating-systems'],
  },
];

export const buildTabData: ServiceGroupStructure[] = [
  {
    name: 'catalog-section.tabs.construction',
    engName: 'build',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/build-new.png/build-new.png`,
    list: ['foundation', 'metal-roof', '318', '1186', '1154', '311', '2137', 'construction-houses'],
  },
];

export const roughWorkTabData: ServiceGroupStructure[] = [
  {
    name: 'catalog-section.categories.ceilings',
    engName: 'floors',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/floors-new.png/floors-new.png`,
    list: ['ceilings', '1086'],
  },
  {
    name: 'catalog-section.categories.walls',
    engName: 'walls',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/walls-new.png/walls-new.png`,
    list: ['plastering', '1086'],
  },
  {
    name: 'catalog-section.categories.ceilings',
    engName: 'ceilings',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/ceilings-new.png/ceilings-new.png`,
    list: ['1086'],
  },
  {
    name: 'catalog-section.categories.windows',
    engName: 'windows',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/windows-new.png/windows-new.png`,
    list: ['windows', '320'],
  },
];

export const communicationsTabData: ServiceGroupStructure[] = [
  {
    name: 'catalog-section.categories.plumbing',
    engName: 'plumbing',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/plumbing-new.png/plumbing-new.png`,
    list: [
      'bathroom-repair',
      'bathroom',
      'sewerage-systems',
      'filter-systems',
      '325',
      '328',
      '2133',
      '1250',
      '1275',
      '329',
    ],
  },
  {
    name: 'catalog-section.categories.electrician',
    engName: 'electrician',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/electrician-new.png/electrician-new.png`,
    list: ['power-supply-systems', '336', '1637'],
  },
  {
    name: 'catalog-section.categories.ventilation',
    engName: 'ventilation',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/ventilation-new.png/ventilation-new.png`,
    list: ['ventilation-systems', 'heating-systems', '321', '682'],
  },
];

export const finishingTabData: ServiceGroupStructure[] = [
  {
    name: 'catalog-section.categories.floors',
    engName: 'floors',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/floors-new.png/floors-new.png`,
    list: ['323', '2135', '324', '331'],
  },
  {
    name: 'catalog-section.categories.walls',
    engName: 'walls',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/walls-new.png/walls-new.png`,
    list: ['334', '331', '979', '1631', '311', '2134'],
  },
  {
    name: 'catalog-section.categories.ceilings',
    engName: 'ceilings',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/ceilings-new.png/ceilings-new.png`,
    list: ['ceilings', '314', '979', '331'],
  },
  {
    name: 'catalog-section.categories.plumbing',
    engName: 'plumbing',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/plumbing-new.png/plumbing-new.png`,
    list: ['325', '1972'],
  },
  {
    name: 'catalog-section.categories.electrician',
    engName: 'electrician',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/electrician-new.png/electrician-new.png`,
    list: ['322', '336'],
  },
  {
    name: 'catalog-section.categories.doors',
    engName: 'doors',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/doors-new.png/doors-new.png`,
    list: ['entrance-doors', 'room-doors', '1140', '1063'],
  },
];

export const improvementTabData: ServiceGroupStructure[] = [
  {
    name: 'catalog-section.categories.plumbing',
    engName: 'plumbing',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/plumbing-new.png/plumbing-new.png`,
    list: ['1275', '1972'],
  },
  {
    name: 'catalog-section.categories.electrician',
    engName: 'electrician',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/electrician-new.png/electrician-new.png`,
    list: ['322'],
  },
  {
    name: 'catalog-section.categories.windows',
    engName: 'windows',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/windows-new.png/windows-new.png`,
    list: ['1217', '2136'],
  },
  {
    name: 'catalog-section.categories.furniture',
    engName: 'furniture',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/furniture-new.png/furniture-new.png`,
    list: ['kitchen', 'storage', '1832', '337', '2237', '1972', '2524', '325', '859'],
  },
  {
    name: 'catalog-section.categories.garden',
    engName: 'garden',
    iconSrc: `${SERVICES_MAIN_CDN_PATH}/services-icons/garden-new.png/garden-new.png`,
    list: ['fences', '330', '1245', '702', '859', '915', '1135', '1570', '1637'],
  },
];

export const SERVICES_CONTENT_DATA: Record<ServiceTabName, ServiceGroupStructure[]> = {
  [ServiceTabName.All]: allTabData,
  [ServiceTabName.Design]: designTabData,
  [ServiceTabName.Сonstruction]: buildTabData,
  [ServiceTabName.RoughWork]: roughWorkTabData,
  [ServiceTabName.Communications]: communicationsTabData,
  [ServiceTabName.Finishing]: finishingTabData,
  [ServiceTabName.Improvement]: improvementTabData,
};
